import EventEmitter from "../../../utils/EventEmitter";

// import UI Components
import {
    UICol,
    UIPanel,
    UIText
} from '../../../ui/ui.lib';

class Menu2DUILoader extends EventEmitter {

    constructor(editor) {
        super();

        this.editor = editor;
        this.dom = null;

        this.initUI();

        this.editor.on('mount2DLoader', this.onMountObjectLoader);
        this.editor.on('toggle2DLoaderProgress', this.toggleProgress);
        // this.editor.on('update2DProgressContent', this.updateProgress);

    }

    initUI = () => {
        var uiContainer = new UIPanel();
        uiContainer.addClass('wsObjectLoader');

        this.uiLoader = new UIPanel();
        this.uiLoader.addClass('wsObjectLoader--loaderDiv');
        this.uiLoader.addChild(new UICol().addClass('loaderContainer__loaderImg'));
        this.uiText = new UIText('100%', 'Loading Content...', true).addClass('wsObjectLoader--loaderText');
        this.uiLoader.addChild(this.uiText);
        uiContainer.addChild(this.uiLoader);

        uiContainer.setDisplay('none');
        this.dom = uiContainer;
    }

    toggleProgress = (flag, text = undefined) => {

        if(text) { 
            this.uiText.setTextContent(text);
        }

        if(flag === 'none') {
            this.uiText.setTextContent('Loading Content...');
        }
    }

    onMountObjectLoader = (bFlag) => {
        if(bFlag) {
            this.dom.setDisplay('flex');
        } else {
            this.dom.setDisplay('none');
        }
    }
}

export { Menu2DUILoader };